// Console Suppression Utility
// Handles development-only warnings and deprecation messages

// Suppress React Router future flag warnings in development
export const suppressReactRouterWarnings = () => {
  if (process.env.NODE_ENV === 'development') {
    const originalWarn = console.warn;
    
    console.warn = (...args) => {
      const message = args[0];
      
      // Suppress React Router future flag warnings
      if (typeof message === 'string' && (
        message.includes('React Router Future Flag Warning') ||
        message.includes('v7_startTransition') ||
        message.includes('v7_relativeSplatPath') ||
        message.includes('Relative route resolution within Splat routes')
      )) {
        return; // Suppress the warning
      }
      
      // Pass through all other warnings
      originalWarn.apply(console, args);
    };
  }
};

// Suppress specific performance API deprecation warnings
export const suppressPerformanceWarnings = () => {
  if (process.env.NODE_ENV === 'development') {
    const originalWarn = console.warn;
    
    console.warn = (...args) => {
      const message = args[0];
      
      // Suppress specific performance API deprecation warnings
      if (typeof message === 'string' && (
        message.includes('Deprecated API for given entry type') ||
        message.includes('getCoreWebVitals') ||
        message.includes('calculateTBT') ||
        message.includes('safeGetEntriesByType') ||
        message.includes('safeGetPaintTiming')
      )) {
        return; // Suppress the warning
      }
      
      // Pass through all other warnings
      originalWarn.apply(console, args);
    };
  }
};

// Initialize all suppressions
export const initializeConsoleSuppression = () => {
  // Check if warnings are already suppressed by the HTML script
  if (window.__warningsSuppressed) {
    console.log('🔇 Warnings already suppressed by pre-initialization script');
    return;
  }
  
  suppressReactRouterWarnings();
  suppressPerformanceWarnings();
  
  if (process.env.NODE_ENV === 'development') {
    // Set global flag for other utilities to check
    window.__consoleSuppressed = true;
    
    // Also suppress console.warn globally for specific patterns
    const originalWarn = console.warn;
    console.warn = (...args) => {
      const stack = new Error().stack || '';
      
      // Suppress React Router warnings by stack trace
      if (stack.includes('react-router') || stack.includes('bundle.js:57931')) {
        return;
      }
      
      // Suppress performance API warnings by stack trace
      if (stack.includes('safeGetEntriesByType') || 
          stack.includes('safeGetPaintTiming') ||
          stack.includes('getCoreWebVitals') ||
          stack.includes('bundle.js:71077')) {
        return;
      }
      
      // Pass through all other warnings
      originalWarn.apply(console, args);
    };
    
    console.log('🔇 Console warnings suppressed for development');
  }
};
